const NotProtectedRoute = ({ children }) => {
  return children;
};

export default NotProtectedRoute;
